import {
  Component, OnInit, ViewEncapsulation,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from 'src/app/utils/translate.service';
import { DoenKidsAuth0Provider } from 'src/providers/auth0.provider';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LoginComponent implements OnInit {

  public timedOut: boolean = false;

  constructor(
    public $auth0Provider: DoenKidsAuth0Provider,
    private $translateService: TranslateService,
    private matDialog: MatDialog,
  ) {}

  ngOnInit() {
    this.$auth0Provider.profile()
      .then((profile) => {
        if (!profile) {
          console.log('[LOGIN] No profile, redirecting to login');
          this.$auth0Provider.login();
        }
      });

    // If the page somehow stalls for a long time, show a timeout error dialog
    // which will allow the user to reload the entire app
    //
    setTimeout(() => {
      this.showTimeoutErrorDialog();
    }, 10000);
  }

  private async showTimeoutErrorDialog() {
    this.timedOut = true;
    const dialogRef = this.matDialog.open(ConfirmationDialogComponent, {
      width: '400px',
      minWidth: '320px',
      data: {
        title: this.$translateService.instant('login.failure'),
        description: this.$translateService.instant('login.restart_app'),
        hideCancel: true,
      },
    });

    const result = await firstValueFrom(dialogRef.afterClosed());

    if (result === 'confirm') {
      document.location.href = '/';
    }
  }
}
